import styled from 'styled-components';
import { buttonBase, getButtonSize, stretchButton } from 'modules/buttonStyles';
import { getFilterButtonAppearance } from './utils';
export const FilterButton = styled.button.attrs((props) => {
    var _a;
    return ({
        type: (_a = props.type) !== null && _a !== void 0 ? _a : 'button',
    });
}) `
  ${buttonBase};
  ${stretchButton};

  ${(props) => getButtonSize(props.size || 'xs')};
  ${(props) => getFilterButtonAppearance(props.appearance)};
`;
